import { defineStyle as l, defineStyleConfig as v } from "@chakra-ui/styled-system";
import { inputTheme as e } from "./input.mjs";
var d;
const y = l({
  ...(d = e.baseStyle) == null ? void 0 : d.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
});
var n, a;
const z = {
  outline: l(
    (t) => {
      var i, s;
      return (s = (i = e.variants) == null ? void 0 : i.outline(t).field) != null ? s : {};
    }
  ),
  flushed: l(
    (t) => {
      var i, s;
      return (s = (i = e.variants) == null ? void 0 : i.flushed(t).field) != null ? s : {};
    }
  ),
  filled: l(
    (t) => {
      var i, s;
      return (s = (i = e.variants) == null ? void 0 : i.filled(t).field) != null ? s : {};
    }
  ),
  unstyled: (a = (n = e.variants) == null ? void 0 : n.unstyled.field) != null ? a : {}
};
var f, o, r, m, u, g, h, p;
const c = {
  xs: (o = (f = e.sizes) == null ? void 0 : f.xs.field) != null ? o : {},
  sm: (m = (r = e.sizes) == null ? void 0 : r.sm.field) != null ? m : {},
  md: (g = (u = e.sizes) == null ? void 0 : u.md.field) != null ? g : {},
  lg: (p = (h = e.sizes) == null ? void 0 : h.lg.field) != null ? p : {}
}, b = v({
  baseStyle: y,
  sizes: c,
  variants: z,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});
export {
  b as textareaTheme
};
